<template>
    <div class="panel panel-info" v-if="telefones && user">
        <!-- Default panel contents -->
        <div class="panel-heading"><i class="fa fa-phone-square" aria-hidden="true"></i> TELEFONES</div>
        <div class="panel-body">

            <form class="form-horizontal" v-if="!readonly && !user.permissoes.cacontrol">

                <div class="form-group">

                    <div class="col-sm-3">
                        <label class="control-label">NÚMERO</label>
                        <input maxlength="14" v-mask="'(##)####-#####'" type="text"
                               v-model="telefone.numero"
                               class="form-control">
                    </div>

                    <div class="col-sm-6">
                        <label class="control-label">CONTATO</label>
                        <input type="text"
                               v-model="telefone.contato"
                               class="form-control">
                    </div>

                    <div class="col-sm-3">
                        <label class="control-label">TIPO</label>
                        <select v-model="telefone.tipo" class="form-control">
                            <option v-for="t in tipos" v-bind:key="t" :value="t">{{ t }}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group">

                    <div class="col-sm-12">
                        <button :disabled="!itsOK" @click.prevent="addTelefone()" class="btn btn-block btn-success">
                            <i class="fa fa-plus-square" aria-hidden="true"></i> ADICIONAR TELEFONE
                        </button>
                    </div>

                </div>
                <br/>
            </form>

            <table id="mytable" class="table table-bordred table-striped">

                <thead>
                <tr>
                    <th style="width: 120px">NÚMERO</th>
                    <th style="width: 120px">TIPO</th>
                    <th>CONTATO</th>
                    <th style="width: 80px; text-align: center" v-if="!readonly">ACOES</th>
                </tr>
                </thead>

                <tbody>

                <tr v-for="r in telefones" v-bind:key="r.numero">
                    <td>{{ r.numero }}</td>
                    <td>{{ r.tipo }}</td>
                    <td>{{ r.contato | uppercase }}</td>
                    <td style="text-align: center" v-if="!readonly && !user.permissoes.cacontrol">
                        <button @click.prevent="editTelefone(r)"
                                class="btn btn-danger btn-xs">
                            <i class="fa fa-pencil-square" aria-hidden="true"></i>
                        </button>
                    </td>
                </tr>

                </tbody>

            </table>

        </div>
    </div>
</template>
<script>
import { Telefone } from "../../class/telefones";

export default {
    props: {
        telefones: {
            type: Array,
            default: function() {
                return [];
            }
        },
        readonly: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            user: null,
            telefone: Telefone.create(),
            tipos: [
                "RESIDENCIAL",
                "COBRANCA",
                "COMERCIAL",
                "CELULAR",
                "FAX",
                "OUTROS"
            ]
        };
    },
    computed: {
        itsOK: function() {
            if (!this.telefone.tipo || !this.telefone.numero) {
                return false;
            }
            return true;
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
    },
    methods: {
        addTelefone() {
            this.telefones.splice(this.telefones.indexOf(this.telefone), 1);
            this.telefones.push(this.telefone);
            this.telefone = Telefone.create();
        },
        editTelefone(tel) {
            this.telefone = tel;
        }
    }
};
</script>
